export const storiesCategory = 'TopicMap Components/';
